<script lang="ts">
  import { onMount } from 'svelte';
  import { auth } from '../lib/auth';
  import { push } from 'svelte-spa-router';
  import { refreshSettings } from '../stores/settings';

  onMount(() => {
    // Call the logout function
    auth.logout();
    
    // Refresh the settings store to reset it to initial state
    refreshSettings()
      .catch(error => {
        console.error('Failed to refresh settings after logout:', error);
      });
      
    // Redirect to the login page, use setTimeout to avoid race conditions
    setTimeout(() => {
      push('/login');
    }, 200);
  });
</script>

<div>
  <p>Logging out...</p>
</div> 